module.exports = "<template> <div class=tyl-avatar aria-hidden=true part=root> <slot></slot> </div> </template>";